import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const Page404 = () => {
    const location = useLocation();
    console.log("Page404",location.pathname);
    console.log(location.search);
    const navigate = useNavigate();
    let applicationMode: any = location.pathname.split('/')[1];
    if (!['odoo', "QBO", "xero", "zoho", "qbo"].includes(applicationMode)) {
        applicationMode = undefined;
    }
    useEffect(() => {
        if (applicationMode) {
            navigate({ pathname: "/login", search: location.search });
        }
    }, [applicationMode, navigate, location.search]);

    return (
        <>
            <h1>404 Welcome</h1>
        </>
    );
};

export default Page404;
